// Generated by purs version 0.15.15
import * as Control_Bind from "../Control.Bind/index.js";
import * as Control_Monad_Except_Trans from "../Control.Monad.Except.Trans/index.js";
import * as Data_Functor from "../Data.Functor/index.js";
import * as Data_Generic_Rep from "../Data.Generic.Rep/index.js";
import * as Data_Identity from "../Data.Identity/index.js";
import * as Foreign from "../Foreign/index.js";
import * as Foreign_Generic_Class from "../Foreign.Generic.Class/index.js";
import * as Foreign_Internal_Stringify from "../Foreign.Internal.Stringify/index.js";
import * as Foreign_JSON from "../Foreign.JSON/index.js";
var map = /* #__PURE__ */ Data_Functor.map(/* #__PURE__ */ Control_Monad_Except_Trans.functorExceptT(Data_Identity.functorIdentity));
var composeKleisliFlipped = /* #__PURE__ */ Control_Bind.composeKleisliFlipped(/* #__PURE__ */ Control_Monad_Except_Trans.bindExceptT(Data_Identity.monadIdentity));
var genericEncode = function (dictGeneric) {
    var from = Data_Generic_Rep.from(dictGeneric);
    return function (dictGenericEncode) {
        var encodeOpts = Foreign_Generic_Class.encodeOpts(dictGenericEncode);
        return function (opts) {
            var $25 = encodeOpts(opts);
            return function ($26) {
                return $25(from($26));
            };
        };
    };
};
var genericEncodeJSON = function (dictGeneric) {
    var genericEncode1 = genericEncode(dictGeneric);
    return function (dictGenericEncode) {
        var genericEncode2 = genericEncode1(dictGenericEncode);
        return function (opts) {
            var $27 = genericEncode2(opts);
            return function ($28) {
                return Foreign_Internal_Stringify.unsafeStringify($27($28));
            };
        };
    };
};
var genericDecode = function (dictGeneric) {
    var to = Data_Generic_Rep.to(dictGeneric);
    return function (dictGenericDecode) {
        var decodeOpts = Foreign_Generic_Class.decodeOpts(dictGenericDecode);
        return function (opts) {
            var $29 = map(to);
            var $30 = decodeOpts(opts);
            return function ($31) {
                return $29($30($31));
            };
        };
    };
};
var genericDecodeJSON = function (dictGeneric) {
    var genericDecode1 = genericDecode(dictGeneric);
    return function (dictGenericDecode) {
        var genericDecode2 = genericDecode1(dictGenericDecode);
        return function (opts) {
            return composeKleisliFlipped(genericDecode2(opts))(Foreign_JSON.parseJSON);
        };
    };
};
var encodeJSON = function (dictEncode) {
    var $32 = Foreign_Generic_Class.encode(dictEncode);
    return function ($33) {
        return Foreign_Internal_Stringify.unsafeStringify($32($33));
    };
};
var decodeJSON = function (dictDecode) {
    return Foreign_JSON.decodeJSONWith(Foreign_Generic_Class.decode(dictDecode));
};
export {
    genericDecode,
    genericEncode,
    decodeJSON,
    encodeJSON,
    genericDecodeJSON,
    genericEncodeJSON
};
export {
    ErrorAtIndex,
    ErrorAtProperty,
    ForeignError,
    TypeMismatch
} from "../Foreign/index.js";
export {
    TaggedObject,
    decode,
    defaultOptions,
    encode
} from "../Foreign.Generic.Class/index.js";
